import { bonzai, type InferBonzai } from "bonzai"
import * as api from "./v1Endpoints"
import { apiV1Mock } from "./v1Mock"
export { apiV1Mock } from "./v1Mock"

const apiV1 = import.meta.env.MODE === "test" ? apiV1Mock.mocks : api

export type V1 = InferBonzai<typeof v1>
export const v1 = bonzai(apiV1)
